import React, { useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import SearchBox from '../components/SearchBox';
import Button from 'react-bootstrap/Button';
import {
  ClaimSearchFilterType,
  ColXsMdType,
  SelectOptionType,
} from '../utils/Types';
import { claimSearchOption, DEFAULT_OPTION } from '../utils/Constant';
import SelectBox from '../components/SelectBox';

interface IClaimSearchFilterProps {
  onApplyFilters: (claimSearchFilter: ClaimSearchFilterType) => void;
}

const colSize: ColXsMdType = {
  xs: 6,
  md: 3,
};

const defaultFilter: ClaimSearchFilterType = {
  searchBy: DEFAULT_OPTION,
  text: '',
};

function ClaimSearchFilter({
  onApplyFilters,
}: Readonly<IClaimSearchFilterProps>) {
  const [claimSearchFilter, setClaimSearchFilter] =
    useState<ClaimSearchFilterType>(defaultFilter);
  const [errors, setErrors] = useState<{ searchBy?: string; text?: string }>(
    {}
  );

  const handleSearch = () => {
    const newErrors: { searchBy?: string; text?: string } = {};

    // Check if dropdown is selected
    if (
      !claimSearchFilter.searchBy?.value ||
      claimSearchFilter.searchBy.value === 'select' ||
      claimSearchFilter.searchBy.value === ''
    ) {
      newErrors.searchBy = 'Please select the Search Type';
      setErrors(newErrors);
      return; // Stop further validation
    }

    // Validate text field only if dropdown is valid
    if (!claimSearchFilter.text.trim()) {
      newErrors.text = 'Please enter a value';
    }

    if (claimSearchFilter.searchBy.value === 'mobileNo') {
      const mobileRegex = /^[0-9]{10}$/;
      if (!mobileRegex.test(claimSearchFilter.text)) {
        newErrors.text = 'Please enter a valid 10-digit mobile number';
      }
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onApplyFilters(claimSearchFilter);
  };
  const handleReset = () => {
    setClaimSearchFilter(defaultFilter);
    setErrors({});
    onApplyFilters(defaultFilter);
  };

  return (
    <div className="border rounded ps-3 pt-2 pb-3 pe-3">
      <Row>
        <Col {...colSize}>
          <SelectBox
            label="Search By Type"
            options={claimSearchOption}
            className="css-select-bg"
            hideMargin={true}
            value={claimSearchFilter.searchBy ?? ''}
            onChange={(event: SelectOptionType) => {
              setClaimSearchFilter((prev) => ({
                ...prev,
                searchBy: event,
                text: '',
              }));
              setErrors((prev) => ({ ...prev, searchBy: undefined }));
              if (claimSearchFilter.searchBy.value === '') {
                setClaimSearchFilter((prev) => ({
                  ...prev,
                }));
                setErrors((prev) => ({ ...prev, text: undefined }));
              }
            }}
          />
          <div
            className="text-danger"
            style={{
              marginTop: '2px',
              color: 'red',
              fontSize: '0.75rem',
              lineHeight: '1rem',
            }}
          >
            {errors.searchBy ?? ''}
          </div>
        </Col>
        <Col {...colSize}>
          <SearchBox
            className="mb-0 button-container w-100"
            label={
              claimSearchFilter.searchBy?.value &&
              claimSearchFilter.searchBy.value !== 'select'
                ? `Enter ${claimSearchFilter.searchBy.label}`
                : 'Select Search Type'
            }
            placeHolder={
              claimSearchFilter.searchBy?.value &&
              claimSearchFilter.searchBy.value !== 'select'
                ? `Enter ${claimSearchFilter.searchBy.label}`
                : 'Select Search Type'
            }
            value={claimSearchFilter.text}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const input = e.target.value;

              if (claimSearchFilter.searchBy?.value === 'mobileNo') {
                if (/^\d{0,10}$/.test(input)) {
                  setClaimSearchFilter((prev) => ({
                    ...prev,
                    text: input,
                  }));
                  setErrors((prev) => ({ ...prev, text: undefined }));
                }
              } else {
                setClaimSearchFilter((prev) => ({
                  ...prev,
                  text: input,
                }));
                setErrors((prev) => ({ ...prev, text: undefined }));
              }
            }}
          />
          <div
            className="text-danger"
            style={{
              marginTop: '2px',
              padding: 0,
              color: 'red',
              fontSize: '0.75rem',
              lineHeight: '1rem',
            }}
          >
            {errors.text ?? ''}
          </div>
        </Col>
      </Row>

      <Row>
        <Col
          xs={12}
          md={4}
          className="d-flex align-items-center pt-1 filter-button-parent"
        >
          <Button
            variant="primary"
            className="cl-btn-primary"
            onClick={handleSearch}
          >
            Search
          </Button>
          <Button
            variant="outline-primary"
            className="mx-2 cl-btn-outline-primary"
            onClick={handleReset}
          >
            Reset
          </Button>
        </Col>
      </Row>
    </div>
  );
}

export default ClaimSearchFilter;
